<template>
  <div class="row pt-1" v-if="berechtigungen.m_korrespondenz.read">
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>{{ $t("global.dashboard_communication") }}</span>
          </div>
          <div class="body">
            <div class="row">
              <div :class="kachelCol">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link :to="{ name: 'korrespondenz-liste' }">
                    <div class="tile bg-pink inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-print"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("global.dashboard_correspondence") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelCol">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link :to="{ name: 'mail-liste' }">
                    <div class="tile bg-pink inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-envelope-open-text"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("global.dashboard_mails") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelCol" v-if="berechtigungen.m_dokumente.read">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link :to="{ name: 'Dokumentenliste' }">
                    <div class="tile bg-pink inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-file-upload"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("global.dashboard_documents") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelCol" v-if="berechtigungen.m_notizen.read">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link :to="{ name: 'notizen-liste' }">
                    <div class="tile bg-light-pink inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-comments-alt"
                          transform="shrink-4 left-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("global.dashboard_notes") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { defineComponent } from '@vue/composition-api'

export default {
  name: "StartseiteKommunikation",
  components: {},
  mixins: [],
  props: {
    kachelStyle: { type: String },
    kachelCol: { type: String },
    kachelKleinStyle: { type: String },
    kachelKleinCol: { type: String },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>
